module.exports = __webpack_public_path__ + "img/doc.1c3a899c.png";